/**
 * @file Constants
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @private
 */

export const LeftMouseButton = 1
export const MiddleMouseButton = 2
export const RightMouseButton = 3
